import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-52982d90"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "login__form" };
const _hoisted_2 = { class: "login__form-group" };
const _hoisted_3 = { for: "fullname" };
const _hoisted_4 = ["value"];
const _hoisted_5 = { class: "login__form-group" };
const _hoisted_6 = { for: "store" };
const _hoisted_7 = ["value"];
const _hoisted_8 = { class: "login__form-group" };
const _hoisted_9 = { for: "profile" };
const _hoisted_10 = ["value"];
const _hoisted_11 = { class: "login__form-group" };
const _hoisted_12 = { for: "email" };
const _hoisted_13 = ["placeholder"];
const _hoisted_14 = {
    key: 0,
    class: "login__form-error"
};
const _hoisted_15 = { class: "login__form-group" };
const _hoisted_16 = { for: "nickname" };
const _hoisted_17 = ["placeholder"];
const _hoisted_18 = {
    key: 0,
    class: "login__form-error"
};
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "*", -1));
const _hoisted_20 = { class: "login__form-actions" };
import { useAppAuth } from '@/features/Login360/app/composables';
import i18n from '@/i18n';
import { computed, reactive } from 'vue';
import * as z from 'zod';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AppRegisterForm',
    setup(__props) {
        const { t } = i18n.global;
        const { loading, userData, goBack, createUser } = useAppAuth();
        const formData = reactive({ email: '', nickname: '' });
        const formErrors = reactive({ email: '', nickname: '' });
        const disabledSubmit = computed(() => {
            return !formData.email || !formData.nickname || loading.value;
        });
        const userSchema = z.object({
            email: z.string().email({ message: t('login360.register.errors.invalidEmail') }),
            nickname: z.string().min(2, { message: t('login360.register.errors.nicknameMinLength') }),
        });
        function submit() {
            const { email, nickname } = formData;
            const { success, error } = userSchema.safeParse({ email, nickname });
            formErrors.email = '';
            formErrors.nickname = '';
            if (!success) {
                error.issues.forEach(({ path, message }) => {
                    if (path[0] === 'email')
                        formErrors.email = message || '';
                    if (path[0] === 'nickname')
                        formErrors.nickname = message || '';
                });
                return;
            }
            createUser({ email, nickname });
        }
        return (_ctx, _cache) => {
            const _component_el_button = _resolveComponent("el-button");
            return (_openBlock(), _createElementBlock("form", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('login360.register.fullname.label')), 1),
                    _createElementVNode("input", {
                        value: _unref(userData)?.name ?? '',
                        id: "fullname",
                        type: "text",
                        readonly: ""
                    }, null, 8, _hoisted_4)
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('login360.register.store.label')), 1),
                    _createElementVNode("input", {
                        value: _unref(userData)?.store ?? '',
                        id: "store",
                        type: "text",
                        readonly: ""
                    }, null, 8, _hoisted_7)
                ]),
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('login360.register.profile.label')), 1),
                    _createElementVNode("input", {
                        value: _unref(userData)?.profile ?? '',
                        id: "profile",
                        type: "text",
                        readonly: ""
                    }, null, 8, _hoisted_10)
                ]),
                _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('login360.register.email.label')), 1),
                    _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((formData.email) = $event)),
                        id: "email",
                        type: "email",
                        placeholder: _ctx.$t('login360.register.email.placeholder'),
                        required: ""
                    }, null, 8, _hoisted_13), [
                        [_vModelText, formData.email]
                    ]),
                    _createVNode(_Transition, null, {
                        default: _withCtx(() => [
                            (formErrors.email)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_14, _toDisplayString(formErrors.email), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    })
                ]),
                _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('login360.register.nickname.label')), 1),
                    _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((formData.nickname) = $event)),
                        id: "nickname",
                        type: "text",
                        placeholder: _ctx.$t('login360.register.nickname.placeholder'),
                        required: ""
                    }, null, 8, _hoisted_17), [
                        [_vModelText, formData.nickname]
                    ]),
                    _createVNode(_Transition, null, {
                        default: _withCtx(() => [
                            (formErrors.nickname)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_18, _toDisplayString(formErrors.nickname), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    }),
                    _createElementVNode("small", null, [
                        _hoisted_19,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('login360.register.nickname.hint')), 1)
                    ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_el_button, {
                        round: "",
                        loading: _unref(loading),
                        disabled: disabledSubmit.value,
                        onClick: _withModifiers(submit, ["prevent"])
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('login360.register.saveButton')), 1)
                        ]),
                        _: 1
                    }, 8, ["loading", "disabled", "onClick"]),
                    _createVNode(_component_el_button, { onClick: _unref(goBack) }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('login360.register.backButton')), 1)
                        ]),
                        _: 1
                    }, 8, ["onClick"])
                ])
            ]));
        };
    }
});
